import React, { useState } from 'react';
import './ParsedEmails.css';

const EMAIL_TYPES = [
  { value: '', label: 'All Types' },
  { value: 'Application Confirmation', label: 'Application Confirmation' },
  { value: 'Application Rejection', label: 'Application Rejection' },
  { value: 'Interview Request', label: 'Interview Request' },
  { value: 'Follow Up', label: 'Follow Up' },
  { value: 'Job Offer', label: 'Job Offer' },
  { value: 'Job Alert', label: 'Job Alert' },
  { value: 'Assessment Invitation', label: 'Assessment Invitation' },
  { value: 'General Information', label: 'General Information' },
  { value: 'Error', label: 'Error' },
];

const MOCK_EMAILS = [
  {
    id: '1',
    outlookEmailId: 'outlook-123',
    subject: 'A message from Fannie Mae',
    candidateEmail: 'mohankrishnapasupuleti18@gmail.com',
    companyName: 'Fannie Mae',
    emailType: 'Application Confirmation',
    jobRole: 'Software Engineer',
    receivedDate: '2025-08-27T10:00:00',
    originalDate: 'Wed, 27 Aug 2025 10:00:00 GMT',
    summary: 'Congratulations, your application is received.',
    originalSender: 'hr@fanniemae.com',
    isMatched: true,
    matchedTaskId: 'task-001',
    createdAt: '2025-08-27T10:01:00',
    updatedAt: '2025-08-27T10:02:00',
  },
  {
    id: '2',
    outlookEmailId: null,
    subject: 'Your Application to Bank OZK',
    candidateEmail: 'veeramanoharreddyalavalapati@gmail.com',
    companyName: 'Bank OZK',
    emailType: 'Application Rejection',
    jobRole: 'Data Analyst',
    receivedDate: '2025-08-26T09:00:00',
    originalDate: 'Tue, 26 Aug 2025 09:00:00 GMT',
    summary: 'We regret to inform you...',
    originalSender: 'noreply@ozk.com',
    isMatched: false,
    matchedTaskId: '',
    createdAt: '2025-08-26T09:01:00',
    updatedAt: '2025-08-26T09:02:00',
  },
];

function ParsedEmails() {
  const [candidateEmail, setCandidateEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [emailType, setEmailType] = useState('');
  const [receivedDate, setReceivedDate] = useState('');
  const [results, setResults] = useState(MOCK_EMAILS);

  const handleSearch = (e) => {
    e.preventDefault();
    // TODO: Replace with API call
    setResults(MOCK_EMAILS.filter(email => {
      return (
        (!candidateEmail || email.candidateEmail.includes(candidateEmail)) &&
        (!companyName || email.companyName.toLowerCase().includes(companyName.toLowerCase()))
      );
    }));
  };

  return (
    <div className="main-content">
      <h1 className="main-title">Parsed Emails</h1>
      <form className="search-form" onSubmit={handleSearch}>
        <div className="input-group">
          <label className="input-label">Candidate Email</label>
          <input
            className="form-input"
            placeholder="e.g., user@example.com"
            value={candidateEmail}
            onChange={e => setCandidateEmail(e.target.value)}
          />
        </div>
        <div className="input-group">
          <label className="input-label">Company Name</label>
          <input
            className="form-input"
            placeholder="e.g., Acme Corp"
            value={companyName}
            onChange={e => setCompanyName(e.target.value)}
          />
        </div>
        <div className="input-group">
          <label className="input-label">Email Type</label>
          <select
            className="form-input"
            value={emailType}
            onChange={e => setEmailType(e.target.value)}
          >
            {EMAIL_TYPES.map(type => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label className="input-label">Received Date</label>
          <input
            className="form-input"
            type="date"
            value={receivedDate}
            onChange={e => setReceivedDate(e.target.value)}
          />
        </div>
        <button className="search-btn" type="submit">Search</button>
      </form>
      <div className="results-table-scroll">
        <div className="results-table-inner">
          <div className="results-header">
            <div>ID</div>
            <div>Outlook Email ID</div>
            <div>Subject</div>
            <div>Candidate Email</div>
            <div>Company Name</div>
            <div>Email Type</div>
            <div>Job Role</div>
            <div>Received Date</div>
            <div>Original Date</div>
            <div>Summary</div>
            <div>Original Sender</div>
            <div>Is Matched</div>
            <div>Matched Task ID</div>
            <div>Created At</div>
            <div>Updated At</div>
          </div>
          {results.map((email, idx) => (
            <div className="results-row" key={idx}>
              <div>{email.id}</div>
              <div>{email.outlookEmailId || ''}</div>
              <div>{email.subject}</div>
              <div>{email.candidateEmail}</div>
              <div>{email.companyName}</div>
              <div>{email.emailType}</div>
              <div>{email.jobRole}</div>
              <div>{email.receivedDate}</div>
              <div>{email.originalDate}</div>
              <div>{email.summary}</div>
              <div>{email.originalSender}</div>
              <div>{email.isMatched ? 'Yes' : 'No'}</div>
              <div>{email.matchedTaskId}</div>
              <div>{email.createdAt}</div>
              <div>{email.updatedAt}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ParsedEmails;
